<div class="container mx-auto">
  <!-- Section Header -->
  <div class="flex flex-wrap items-center justify-between mb-6 pb-4 border-b border-base-300">
    <div class="flex-1">
      <h2 class="text-2xl font-bold text-base-content flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.069A1 1 0 0121 8.87v6.26a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
        Past Recordings
      </h2>
      <p class="text-sm text-base-content/60 mt-1">Recordings from your subscribed live classes</p>
    </div>
    <a
      routerLink="/dashboard/meetings"
      class="daisy-btn daisy-btn-ghost daisy-btn-sm gap-2"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      View Meetings
    </a>
  </div>

  <div>
    @if (sessionRecordings.length === 0) {
    <div class="daisy-alert">
      <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>No past recordings available. Recordings from your subscribed live classes will appear here.</span>
    </div>
    } @else {
    @for (item of sessionRecordings; track item) {
    <black-recording-card
      [session]="item"
      (playVideoEvent)="playVideo($event)"
    ></black-recording-card>
    }
    }
  </div>
</div>
